import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { StyledToastButton } from "./styles";

type Props = {
    onReset: VoidFunction;
};

export const HiddenCompaniesToast = ({ onReset }: Props) => {
    const { translate } = useTranslate();

    return (
        <Flex
            alignItems="center"
            gap="8px"
        >
            <Text
                fontVariant="input2"
                color={colorsPalettes.carbon[0]}
            >
                {translate("si.lists.add.companies.hidden.toast.message")}
            </Text>
            <StyledToastButton
                type="flat"
                onClick={onReset}
            >
                {translate("si.lists.add.companies.hidden.toast.button")}
            </StyledToastButton>
        </Flex>
    );
};
